const styles = (theme) => ({
  LoginBox: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: `url(
            ${require(`../../assets/images/login-banner.png`)}
          )`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
    backgroundSize: 'cover',
    flexDirection: 'column',
    '@media screen and (max-device-width: 1024px)': {
      // flexDirection: 'column',
    },
  },
  LoginContainer: {
    height: '100%',
  },
  LoginFormPaper: {
    maxWidth: '500px',
    mt: 4,
    mb: 4,
    marginLeft: 'auto',
    marginRight: 'auto',
    p: 3,
    boxShadow:
      '0px 8px 9px -5px rgba(0, 0, 0, 0.2), 0px 15px 22px 2px rgba(0, 0, 0, 0.14), 0px 6px 28px 5px rgba(0, 0, 0, 0.12)',
    '@media screen and (max-device-width: 767px)': {
      m: 2,
      borderRadius: '0px',
    },
  },
  LoginFormlogo: {
    '& svg': {
      margin: '0 auto 0px',
      display: 'flex',
    },
  },
  LoginHeading: {
    color: theme.palette.text.secondary,
    textAlign: 'center',
  },
  LoginFormInfo: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightRegular,
  },
  LoginDivider: {
    position: 'relative',
    mt: 3,
    mb: 6,
  },
  OrDividerText: {
    position: 'absolute',
    top: '50%',
    textAlign: 'center',
    background: '#fff',
    padding: '0 10px',
    transform: 'translate(-50%, -50%)',
    left: '50%',
    color: theme.palette.text.primary,
  },
  LightRedButton: {
    background: '#E32124',
    borderColor: '#E32124',
    '&:hover': {
      background: '#D41E21',
      borderColor: '#D41E21',
    },
  },
  DarkRedButton: {
    background: '#B8232F',
    borderColor: '#B8232F',
    '&:hover': {
      background: '#A51F2A',
      borderColor: '#A51F2A',
    },
  },
  SkyBlueButton: {
    background: '#007FC7',
    borderColor: '#007FC7',
    '&:hover': {
      background: '#0074B6',
      borderColor: '#0074B6',
    },
  },
  LightBlueButton: {
    background: '#00ADEF',
    borderColor: '#00ADEF',
    '&:hover': {
      background: '#2A547E',
      borderColor: '#2A547E',
    },
  },
  DarkBlueButton: {
    background: '#002C7A',
    borderColor: '#002C7A',
    '&:hover': {
      background: '#01215B',
      borderColor: '#01215B',
    },
  },
  CommonMultiFactor: {
    minHeight: '50px',
  },
  RememberMe: {
    pl: 2,
  },
  BottomCasehubLogo: {
    textAlign: 'center',
    mb: 2,
    mt: 3,
    display: 'none',
    '@media screen and (max-device-width: 767px)': {
      display: 'block',
    },
  },
});

export default styles;
